import { Typography } from '@mui/material';
import EditableTextField from 'components/editableTextField';
import DeferWrapper from 'components/Input/DeferWrapper';
import StringInput from 'components/Input/StringInput';
import React from 'react';
import { FinsightEntityField } from 'shared';
import { formatName } from 'utils/fields';

export function StringRenderer({
  field,
  value,
  editable,
  onChange,
}: {
  field: FinsightEntityField;
  value: unknown;
  editable?: boolean;
  onChange?: (value: unknown) => Promise<void>;
}) {
  if (editable) {
    return (true as any) ? (
      <DeferWrapper
        latestValue={value as string}
        onChange={async (v) => onChange?.(v)}
        component={StringInput}
        componentsProps={{
          label: formatName(field.name ?? ''),
          required: field.schema.required,
        }}
      />
    ) : (
      <EditableTextField
        notBlank={field.schema.required}
        variant="outlined"
        label={formatName(field.name ?? '')}
        value={value}
        onChange={async (v) => onChange?.(v)}
      />
    );
  }

  if (typeof value !== 'string') return null;

  return <Typography>{value}</Typography>;
}
